import { psNotes } from '@pt/utils/storage'
function getInitState() {
  return {
    estimateLimitTips: false,
    packageLimitDialog: !psNotes.get(),
  }
}

export default {
  namespaced: true,

  state: getInitState(),

  mutations: {
    updateEstimateLimitTips(state, value) {
      state.estimateLimitTips = value
    },
    updatePackageLimitDialog(state, value) {
      state.packageLimitDialog = value
    },
  },

  actions: {},
}
